import React = require("react")

const StoreContext = React.createContext({})

export default StoreContext


// WEBPACK FOOTER //
// ./src/context/store.tsx